export default __webpack_public_path__ + "src/assets/membership-expired.17d3b6bb2954038feab8f70e307d5754.svg";